import {
  takeLatest,
  takeEvery,
  call,
  put,
  all,
  select
} from 'redux-saga/effects'
import moment from 'moment'
import { change, initialize } from 'redux-form'
import _ from 'lodash'

import { CONSTANTS } from './reducer'
import { showNotification, hideLoading } from '../../../store/global'
import {
  getListMeetingRoom,
  getListBooking,
  getDetailBooking,
  createBooking,
  updateBooking,
  deleteBooking,
  deleteBookingRepeat
} from '../../../api/meetingRoomBooking'
import { getListEmployee } from '../../../api/employee'
import { replaceLocation } from '../../../store/location'
import { isEqualDate } from '../../../utils/dateUtils'
import { getUserData } from '../../../utils/token'

function* getRoomList() {
  try {
    const { roomList } = yield select(state => state.meetingRoomBooking)
    let { meetingRoomID } = yield select(state => state.meetingRoomBooking)

    const roomListActive = _.filter(roomList, function(i) {
      return i.Status === 1
    })

    if (roomListActive.length > 0) {
      if (!meetingRoomID) {
        meetingRoomID = roomListActive[0] ? roomListActive[0].ID : null
      }
      yield put({
        type: CONSTANTS.ROOM_LIST_SUCCESS,
        list: roomListActive,
        meetingRoomID
      })
      if (meetingRoomID) {
        yield* onMeetingRoomChange({ roomID: meetingRoomID })
      }

      return
    }

    const response = yield call(getListMeetingRoom)

    if (response.result === 'fail') {
      throw new Error(response.errorMessage)
    }

    const roomListActiveRequest = _.filter(response.items, function(o) {
      return o.Status === 1
    })

    if (!meetingRoomID) {
      meetingRoomID = roomListActiveRequest[0]
        ? roomListActiveRequest[0].ID
        : null
    }

    yield put({
      type: CONSTANTS.ROOM_LIST_SUCCESS,
      list: roomListActiveRequest,
      meetingRoomID
    })
    if (meetingRoomID) {
      yield* onMeetingRoomChange({ roomID: meetingRoomID })
    }
  } catch (error) {
    const message =
      (error.response && error.response.data.Message) || error.message
    yield put(showNotification(message, 30000, true))
    yield put({ type: CONSTANTS.ROOM_LIST_FAILURE })
  }
}

function* getBookingList({ meetingRoomID, from, to }) {
  try {
    const response = yield call(getListBooking, {
      from,
      to,
      meetingRoomID
    })

    if (response.result === 'fail') {
      throw new Error(response.errorMessage)
    }

    yield put({ type: CONSTANTS.BOOKING_LIST_SUCCESS, items: response.items })
  } catch (error) {
    const message =
      (error.response && error.response.data.Message) || error.message
    yield put(showNotification(message, 30000, true))
    yield put({ type: CONSTANTS.BOOKING_LIST_FAILURE })
  }
}

function* onMeetingRoomChange({ roomID }) {
  const { dateList } = yield select(state => state.meetingRoomBooking)

  if (!roomID) {
    return
  }

  const fromDate = moment(dateList[0]).format('DD/MM/YYYY')
  const toDate = moment(dateList[dateList.length - 1]).format('DD/MM/YYYY')

  yield put({
    type: CONSTANTS.BOOKING_LIST_REQUEST,
    meetingRoomID: roomID,
    from: fromDate,
    to: toDate
  })
}

function* onBookingDateChange({ bookingDate }) {
  const { meetingRoomID, dateList } = yield select(
    state => state.meetingRoomBooking
  )

  const choosenDate = dateList.find(date => isEqualDate(date, bookingDate))

  yield put({
    type: CONSTANTS.GENERATE_WEEK_ARRAY,
    bookingDate,
    needToRegen: choosenDate !== null
  })

  yield* onMeetingRoomChange({ meetingRoomID })
}

function* getEmployeesProfile({ textFind }) {
  try {
    const response = yield call(getListEmployee, { textFind })

    if (response.HasError) {
      throw new Error(response.Error)
    }

    yield put({
      type: CONSTANTS.EMPLOYEES_PROFILE_SUCCESS,
      profiles: response.Data.Items
    })
  } catch (error) {
    const message =
      (error.response && error.response.data.Message) || error.message
    yield put(showNotification(message, 30000, true))
    yield put({ type: CONSTANTS.EMPLOYEES_PROFILE_FAILURE })
  }
}

function* getBookingDetail({ bookingId }) {
  try {
    const response = yield call(getDetailBooking, bookingId)

    if (response.result === 'fail') {
      throw new Error(response.errorMessage)
    }

    const data = response.item

    yield put({ type: CONSTANTS.SET_START_TIME, choosenTime: data.StartTime })
    yield put({ type: CONSTANTS.SET_END_TIME, choosenTime: data.EndTime })

    yield put({
      type: CONSTANTS.CHANGE_BOOKING_DATE,
      bookingDate: new Date(data.MeetingDay)
    })
    yield put({
      type: CONSTANTS.CHANGE_MEETING_ROOM,
      roomID: data.MeetingRoomID
    })

    yield put(
      initialize('BookingConfigurationForm', {
        meetingRoom: data.MeetingRoomID,
        bookingDate: new Date(data.MeetingDay),
        startTime: data.StartTime,
        endTime: data.EndTime,
        description: data.Description
      })
    )

    const user = getUserData()

    const meetingDay = new Date(data.MeetingDay)
    meetingDay.setHours(
      data.StartTime - (data.StartTime % 1),
      data.StartTime % 1 > 0 ? 30 : 0
    )

    yield put({
      type: CONSTANTS.BOOKING_DETAIL_SUCCESS,
      internalMembers: data.attendees.filter(member => member.ID),
      externalMembers: data.attendees.filter(member => !member.ID),
      isEdit:
        data.BookingByEmployeeID === user.EmployeeId && new Date() <= meetingDay
    })
  } catch (error) {
    const message =
      (error.response && error.response.data.Message) || error.message
    yield put(showNotification(message, 30000, true))
    yield put({ type: CONSTANTS.BOOKING_DETAIL_FAILURE })
  }
}

function* onStartTimeChange() {
  yield put(change('BookingConfigurationForm', 'endTime', null))
}

function* onCreateBooking({ formValues }) {
  try {
    const params = {
      meetingRoomID: formValues.meetingRoom,
      meetingDay: moment(formValues.bookingDate).format('DD/MM/YYYY'),
      startTime: formValues.startTime,
      endTime: formValues.endTime,
      description: formValues.description,
      type: formValues.repeatType || 0
    }

    if (formValues.repeatType) {
      params['interval'] = formValues.repeatInterval
      params['untilDate'] = moment(formValues.endDate).format('DD/MM/YYYY')
    }

    const { internalMembers, externalMembers } = yield select(
      state => state.meetingRoomBooking
    )

    params['attendees'] = JSON.stringify(
      internalMembers.concat(externalMembers)
    )

    const response = yield call(createBooking, params)

    if (response.result === 'fail') {
      throw new Error(response.errorMessage)
    }

    yield put({ type: CONSTANTS.BOOKING_CREATE_SUCCESS })
    yield* onBookingDateChange({ bookingDate: formValues.bookingDate })
    yield* onMeetingRoomChange({ meetingRoomID: formValues.meetingRoom })
    yield put(replaceLocation('/meeting-room-booking'))

    yield put(showNotification('Booking success!'))
  } catch (error) {
    const message =
      (error.response && error.response.data.Message) || error.message
    yield put(showNotification(message, 30000, true))
    yield put({ type: CONSTANTS.BOOKING_CREATE_FAILURE })
  } finally {
    yield put(hideLoading())
  }
}

function* onUpdateBooking({ formValues, bookingId }) {
  try {
    const params = {
      meetingRoomID: formValues.meetingRoom,
      meetingDay: moment(formValues.bookingDate).format('DD/MM/YYYY'),
      startTime: formValues.startTime,
      endTime: formValues.endTime,
      description: formValues.description,
      type: formValues.repeatType
    }

    if (formValues.repeatType) {
      params['interval'] = formValues.repeatInterval
      params['untilDate'] = moment(formValues.endDate).format('DD/MM/YYYY')
    }

    const { internalMembers, externalMembers } = yield select(
      state => state.meetingRoomBooking
    )

    params['attendees'] = JSON.stringify(
      internalMembers.concat(externalMembers)
    )

    const response = yield call(updateBooking, bookingId, params)

    if (response.result === 'fail') {
      throw new Error(response.errorMessage)
    }

    yield put({ type: CONSTANTS.BOOKING_UPDATE_SUCCESS })
    yield* onBookingDateChange({ bookingDate: formValues.bookingDate })
    yield* onMeetingRoomChange({ meetingRoomID: formValues.meetingRoom })
    yield put(replaceLocation('/meeting-room-booking'))
    yield put(showNotification('Update success!'))
  } catch (error) {
    const message =
      (error.response && error.response.data.Message) || error.message
    yield put(showNotification(message, 30000, true))
    yield put({ type: CONSTANTS.BOOKING_UPDATE_FAILURE })
  }
}

function* initializeBookingForm() {
  const { startTime, endTime, bookingDate, meetingRoomID } = yield select(
    state => state.meetingRoomBooking
  )

  yield put(
    initialize('BookingConfigurationForm', {
      meetingRoom: meetingRoomID,
      bookingDate: bookingDate < new Date() ? new Date() : bookingDate,
      startTime,
      endTime,
      repeatInterval: 1,
      repeatType: null
    })
  )

  const user = getUserData()

  yield put({
    type: CONSTANTS.INTERNAL_MEMBER_INVITE,
    member: {
      ID: user.EmployeeId,
      Name: user.DisplayName,
      Email: user.Email
    }
  })
}

function* onDeleteBooking({ bookingId, reasons }) {
  try {
    const response = yield call(deleteBooking, bookingId, reasons)

    if (response.result === 'fail') {
      throw new Error(response.errorMessage)
    }

    yield put({
      type: CONSTANTS.BOOKING_DELETE_SUCCESS,
      bookingId
    })

    // yield put(replaceLocation('/meeting-room-booking/'))

    const roomID = yield select(state => state.meetingRoomBooking.meetingRoomID)

    yield* onMeetingRoomChange({ roomID })
  } catch (error) {
    const message =
      (error.response && error.response.data.Message) || error.message
    yield put(showNotification(message, 30000, true))
    yield put({ type: CONSTANTS.BOOKING_DELETE_FAILURE })
  }
}

function* onDeleteRepeatBooking({ SeriesID, reasons }) {
  try {
    const response = yield call(deleteBookingRepeat, SeriesID, reasons)

    if (response.result === 'fail') {
      throw new Error(response.errorMessage)
    }

    yield put({
      type: CONSTANTS.DELETE_REPEAT_MEETING_ROOM_SUCCESS,
      SeriesID
    })

    yield put(replaceLocation('/meeting-room-booking/'))

    const roomID = yield select(state => state.meetingRoomBooking.meetingRoomID)

    yield* onMeetingRoomChange({ roomID })
  } catch (error) {
    const message =
      (error.response && error.response.data.Message) || error.message
    yield put(showNotification(message, 30000, true))
    yield put({ type: CONSTANTS.DELETE_REPEAT_MEETING_ROOM_FAILURE })
  }
}

function* onGenerateWeekArray() {
  const { meetingRoomID } = yield select(state => state.meetingRoomBooking)

  yield* onMeetingRoomChange({ roomID: meetingRoomID })
}

function* roomBookingWatcher() {
  yield all([
    takeLatest(CONSTANTS.ROOM_LIST_REQUEST, getRoomList),
    takeLatest(CONSTANTS.BOOKING_LIST_REQUEST, getBookingList),
    takeLatest(CONSTANTS.GENERATE_WEEK_ARRAY, onGenerateWeekArray),
    takeLatest(CONSTANTS.CHANGE_MEETING_ROOM, onMeetingRoomChange),
    takeLatest(CONSTANTS.CHANGE_BOOKING_DATE, onBookingDateChange),
    takeLatest(CONSTANTS.EMPLOYEES_PROFILE_REQUEST, getEmployeesProfile),
    takeLatest(CONSTANTS.BOOKING_DETAIL_REQUEST, getBookingDetail),
    takeLatest(CONSTANTS.BOOKING_CREATE_REQUEST, onCreateBooking),
    takeLatest(CONSTANTS.BOOKING_UPDATE_REQUEST, onUpdateBooking),
    takeEvery(CONSTANTS.SET_START_TIME, onStartTimeChange),
    takeEvery(CONSTANTS.INITIALIZE_ROOM_BOOKING, initializeBookingForm),
    takeLatest(CONSTANTS.BOOKING_DELETE_REQUEST, onDeleteBooking),
    takeLatest(
      CONSTANTS.DELETE_REPEAT_MEETING_ROOM_REQUEST,
      onDeleteRepeatBooking
    )
  ])
}

export default [roomBookingWatcher()]



// WEBPACK FOOTER //
// ./src/routes/MeetingRoomBookingOverview/modules/saga.js